import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";
import Config from "./Config";
import Roles from "./utils/Roles";
import "./Lang";

if (!Config.isDev()) {
  Sentry.init({
    dsn: "https://e567e8ce7f124345bec1fa959ee32b2a@o485192.ingest.sentry.io/5578950",
    ignoreErrors: ["Object Not Found Matching Id"],
  });
}

let currentWindow: any = window;

if (currentWindow != null) {
  currentWindow.onload = () => {
    Roles.setHotjarUserId();
  };
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
